import { useState } from "react";
import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

export function Readiness() {
  const { t, setQuestionId, setRegisterOpen } = useLanding();
  const [checked, setChecked] = useState(() => t.readiness.checks.map(() => false));
  const score = checked.filter(Boolean).length;
  const [heading, copy] = t.readiness.scores[score];

  const toggle = (index) => setChecked((prev) => prev.map((value, i) => (i === index ? !value : value)));
  // Personalise the registration: low scores start with "where do I start", higher scores with "how it all fits".
  const onReserve = () => {
    const prefill = t.readiness.prefill;
    if (prefill) setQuestionId(score <= 1 ? prefill[0] : score <= 3 ? prefill[1] : prefill[2]);
    setRegisterOpen(true);
  };

  return (
    <InteractiveSection className="section section-cream" data-testid="readiness-section">
      <MotionBg variant="docs" dots={2} />
      <div className="container readiness-grid">
        <Reveal className="check-card">
          <p className="eyebrow"><span className="eyebrow-no">06</span>{t.readiness.eyebrow}</p>
          <h2>{t.readiness.title}</h2>
          <p className="subhead">{t.readiness.lead}</p>
          <div className="check-list">
            {t.readiness.checks.map((text, index) => (
              <label className={`check-item ${checked[index] ? "checked" : ""}`} key={text} data-testid={`check-item-${index}`}>
                <input type="checkbox" checked={checked[index]} onChange={() => toggle(index)} />
                <span className="custom-check">✓</span>
                <span className="check-text">{text}</span>
                <span className="check-status">{t.readiness.confident}</span>
              </label>
            ))}
          </div>
        </Reveal>
        <Reveal as="aside" className="score-card" delay={0.1}>
          <div className="score-ring" style={{ "--score": score }}>
            <div className="score-value">
              <strong data-testid="score-value">{score}</strong>
              <small>{t.readiness.scoreOf}</small>
            </div>
          </div>
          <h3 data-testid="score-heading">{heading}</h3>
          <p>{copy}</p>
          <button type="button" className="btn btn-gold" onClick={onReserve} data-testid="score-cta">{t.readiness.button}</button>
          <span className="score-note">{t.readiness.scoreNote}</span>
        </Reveal>
      </div>
    </InteractiveSection>
  );
}
